export enum SlotInterval {
    Interval_08_12 = 1,
    Interval_12_16 = 2,
    Interval_16_20 = 3
}


class DateHelper {
    static daysOfTheWeekLong: string[] = ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'];
    static daysOfTheWeekShort: string[] = ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'];

    static getHourIn2DigitsFormat(date: Date): string {
        return String(date.getHours()).padStart(2, '0');
    }
    static getMinutesIn2DigitsFormat(date: Date): string {
        return String(date.getMinutes()).padStart(2, '0');
    }
    static getTimeInHHMMFormat(date: Date): string {
        return `${this.getHourIn2DigitsFormat(date)}:${this.getMinutesIn2DigitsFormat(date)}`;
    }
    static getDayIn2DigitsFormat(date: Date): string {
        return String(date.getDate()).padStart(2, '0');
    }
    static getMonthIn2DigitsFormat(date: Date): string {
        return String(date.getMonth() + 1).padStart(2, '0'); // + 1 because months are in range 0-11
    }
    static getDayOfTheWeekLong(date: Date): string {
        const today = new Date();
        const tomorrow = this.addDays(today, 1);
        if (this.areDatesEqual(today, date)) {
            return "dzisiaj";
        }
        else if (this.areDatesEqual(date, tomorrow)) {
            return "jutro";
        }
        return this.daysOfTheWeekLong[date.getDay()];
    }
    static getDayOfTheWeekShort(date: Date): string {
        return this.daysOfTheWeekShort[date.getDay()];
    }
    static getDateLong(date: Date): string {
        return `${this.getDayIn2DigitsFormat(date)}.${this.getMonthIn2DigitsFormat(date)}.${date.getFullYear()}`;
    }
    static getDateShort(date: Date): string {
        return `${this.getDayOfTheWeekShort(date)} ${this.getDayIn2DigitsFormat(date)}.${this.getMonthIn2DigitsFormat(date)}`;
    }
    static getDateForUrl(date: Date): string {
        return `${date.getFullYear()}-${this.getMonthIn2DigitsFormat(date)}-${this.getDayIn2DigitsFormat(date)}`;
    }
    static areDatesEqual(first: Date, second: Date): boolean {
        const d1 = new Date(first.setHours(0, 0, 0, 0)).getTime();
        const d2 = new Date(second.setHours(0, 0, 0, 0)).getTime();
        return d1 === d2;
    }
    static getDates(startDate: Date, stopDate: Date): Date[] {
        const dateArray = new Array();
        let currentDate = startDate;
        while (currentDate <= stopDate) {
            dateArray.push(new Date(currentDate));
            currentDate = this.addDays(currentDate, 1);
        }
        return dateArray;
    }

    static addDays(date: Date, days: number): Date {
        const newDate = new Date(date.valueOf());
        newDate.setDate(newDate.getDate() + days);
        return newDate;
    }

    static addMinutes(date: Date, minutes: number): Date {
        return new Date(date.getTime() + minutes * 60000);
    }

    static getSlotInterval(slotInterval: SlotInterval): string {
        switch (slotInterval) {
            case SlotInterval.Interval_08_12:
                return "08:00-12:00";
            case SlotInterval.Interval_12_16:
                return "12:00-16:00";
            case SlotInterval.Interval_16_20:
                return "16:00-20:00";
            default:
                return "08:00-12:00";
        }
    }
}

export default DateHelper